import { logInfo } from './loggerUtils'
import { redirectTo } from './redirectTo'

const getPodNumberFromOrgId = (orgId?: string) => {
  if (!orgId) return
  return orgId?.substring(3, 5)
}

const getBillBaseUrl = (bdcPodId?: string) =>
  ({
    '01': window.__DivvyEnvironment.BILL_POD1_URL,
    '02': window.__DivvyEnvironment.BILL_POD2_URL,
  })[bdcPodId as '01' | '02']

export const getBillUrl = (bdcOrgId?: string) => {
  const podId = getPodNumberFromOrgId(bdcOrgId)
  return getBillBaseUrl(podId)
}

export const getNeoUrl = (bdcOrgId?: string) => {
  const podId = getPodNumberFromOrgId(bdcOrgId)
  const billUrl = getBillBaseUrl(podId)
  return billUrl ? `${billUrl}/neo` : ''
}

export const getTankUrl = (bdcOrgId?: string) => {
  const podId = getPodNumberFromOrgId(bdcOrgId)
  const billUrl = getBillBaseUrl(podId)
  return billUrl ? `${billUrl}/query` : ''
}

export const logoutBill = (bdcOrgId?: string) => {
  const tankUrl = getTankUrl(bdcOrgId)
  if (!tankUrl) return
  return fetch(tankUrl, {
    method: 'POST',
    body: '{"query":"mutation Mutation { logout }","variables":{},"operationName":"Mutation"}',
    headers: {
      'content-type': 'application/json',
    },
  })
}

export const navigateToBillLogin = (bdcOrgId?: string) => {
  const neoUrl = getNeoUrl(bdcOrgId)
  logInfo('navigateToBillLogin', {
    attributes: {
      bdcOrgId,
      result: `Navigates user to ${neoUrl}/login`,
    },
    eventName: 'BillLogin',
  })
  redirectTo(`${neoUrl}/login`)
}

export const navigateToBillSetup = (bdcOrgId?: string, creditAppId?: string) => {
  const billBaseUrl = getBillUrl(bdcOrgId)

  logInfo('goToBill', {
    attributes: {
      bdcOrgId,
      creditAppId,
      result: `Sending user to path: ${billBaseUrl}/neo/frame/setup`,
    },
    eventName: 'RedirectToBill',
  })
  redirectTo(`${billBaseUrl}/neo/frame/setup`)
}
